import { useCallback, useMemo } from "react";

import {
  copyGifLink,
  getGifFixedEmbedCode,
  getGifResponsiveEmbedCode,
  sendGifToTwitter,
  sendGifToReddit,
} from "@/common/utils/share";

import { ShareMenu } from "./ShareMenu";
import { IShareGifMenuProps } from "@/common/buses/popups/popup-types";
import { EventSource, metricsBus } from "@/common/buses";
import { onCloseShareGifMenu, onOpenAddNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { useUserStore } from "@/common/store/userStore";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

export const ShareGifMenu = (props: IShareGifMenuProps) => {
  const { anchorEl, position, playCount } = props;
  const currentUser = useUserStore((state) => state.currentUser);
  const eventSource = useAnalyticsStore((state) => state.eventSource);
  const sourceId = eventSource?.id ?? null;
  const sourceName = eventSource?.name || EventSource.Other;
  const isAuth = currentUser?.username;

  const gif = useMemo(() => ({
    ...props.gif,
    id: props.gif.aliasId || props.gif.id
  }), []);

  const userIsAuthenticated = useMemo(() => !!isAuth, [isAuth]);
  const isGifPublished = useMemo(() => gif.published, [gif]);

  const handleClose = useCallback(() => {
    onCloseShareGifMenu();
  }, []);

  const handleClick = useCallback(async (label: string) => {
    if (label === "Copy Link") {
      await copyGifLink(gif);
      metricsBus.emit("shareCopy");
    } else if (label === "Discord") {
      await copyGifLink(gif);
      metricsBus.emit("shareDiscord");
    } else if (label === "Reddit") {
      sendGifToReddit(gif);
      metricsBus.emit("shareReddit");
    } else if (label === "Twitter") {
      sendGifToTwitter(gif.id);
      metricsBus.emit("shareTwitter");
    } else if (label === "Add to Niche") {
      onOpenAddNichePopup({ gifId: gif.id });
    }

    metricsBus.emit("gifShared", {
      gifId: gif.id,
      source: sourceName,
      sourceId,
      boosted: !!gif.cta,
      position,
      playCount,
      userName: currentUser?.username,
    });

    handleClose();
  }, [gif, sourceName, sourceId, handleClose, position, playCount]);

  return (
    <ShareMenu
      userIsAuthenticated={userIsAuthenticated}
      isGifPublished={isGifPublished}
      anchorEl={anchorEl}
      onClick={handleClick}
      onClose={handleClose}
      fixedEmbedCode={getGifFixedEmbedCode(gif)}
      responsiveEmbedCode={getGifResponsiveEmbedCode(gif)}
    />
  );
};
